module.exports = __webpack_public_path__ + "img/star4blue.c0b58fb8.png";